import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30412cbc"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "app-auth-flow" };
const _hoisted_2 = { class: "app-auth-flow__logo" };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    class: "app-auth-flow__welcome-msg",
    key: "welcome"
};
const _hoisted_6 = { class: "app-auth-flow__body" };
const _hoisted_7 = { class: "app-auth-flow__modal-header" };
const _hoisted_8 = { class: "app-auth-flow__modal-header-img" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "app-auth-flow__modal-body" };
const _hoisted_11 = { class: "app-auth-flow__modal-header-title" };
const _hoisted_12 = ["innerHTML"];
import { useAppAuth } from '@/features/Login360/app/composables';
import { FormSteps, Screen } from '../../shared/types';
import AppRegisterForm from './AppRegisterForm.vue';
import AppValidateForm from './AppValidateForm.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppLoginFlow',
    setup(__props) {
        const { currentFormView, showSuccessModal, changeCurrentScreen } = useAppAuth();
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("img", {
                        src: require('@/assets/svgs/login/logo-oto.svg'),
                        alt: "Oto"
                    }, null, 8, _hoisted_3),
                    _createVNode(_Transition, {
                        name: "slide-right",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (_unref(currentFormView) === _unref(FormSteps).VALIDATE)
                                ? (_openBlock(), _createElementBlock("img", {
                                    src: require('@/assets/svgs/login/logo-crm.svg'),
                                    alt: "Logo 360",
                                    key: "logo"
                                }, null, 8, _hoisted_4))
                                : (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.$t('login360.app.welcome-title')), 1))
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_Transition, {
                        name: "slide-right",
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentFormView) === _unref(FormSteps).VALIDATE ? AppValidateForm : AppRegisterForm), { key: _unref(currentFormView) }))
                        ]),
                        _: 1
                    })
                ]),
                _createVNode(_component_el_dialog, {
                    modelValue: _unref(showSuccessModal),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(showSuccessModal) ? (showSuccessModal).value = $event : null)),
                    width: "343",
                    center: "",
                    "show-close": false,
                    "modal-class": "app-auth-flow__modal"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("img", {
                                    src: require('@/assets/svgs/login/oto-smile.svg')
                                }, null, 8, _hoisted_9)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('login360.app.success-modal-title')), 1),
                            _createElementVNode("span", {
                                class: "app-auth-flow__modal-description",
                                innerHTML: _ctx.$t('login360.app.success-modal-description')
                            }, null, 8, _hoisted_12),
                            _createVNode(_component_el_button, {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(changeCurrentScreen)(_unref(Screen).SUCCESS)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('login360.app.continue-button')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
